import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Header,
    Textarea,
    Container,
    SpaceBetween,
    Box,
    Grid,
    Link,
    ExpandableSection,
    FileUpload,
    Modal,
    Spinner,
    Checkbox,
    ColumnLayout,
    Select
} from "@amzn/awsui-components-react";
import './styles.scss'
import RippleComponent from "./RippleComponent";
import { getAllRipples } from "src/utilities/AppSyncPlusAPIs";
const RippleComponentManager = (props) => {
    const [rippleConfigurationComponents, setRippleConfigurationComponents] = useState([]);
    const [rippleIds, setRippleIds] = useState(new Set());
    const [loading, setLoading] = useState(null);
    let errors = []
    const rippleConfigurationComponentsRef = useRef([]);
    const requestQueRef = useRef({});
    const deleteRequestRef = useRef(new Set());

    // useEffect(() => {
    //     initView()
    // }, [])

    useEffect(() => {
        initView()
    }, [props.reloadNotifier])

    useEffect(() => {
        notifyUpdates('appId', props.appId)
    }, [props.appId])

    useEffect(() => {
        if (props.shouldSubmit) {
            // make API call here
            requestQueRef.current = new Set(rippleIds)
            if (requestQueRef.current?.size == 0) {
                props.submissionUpdates(true, {})
            } else {
                submitConfigurations(true)
            }
        }
    }, [props])

    useEffect(() => {
        notifyUpdates('isEditMode', props.isEditMode)
    }, [props.isEditMode])

    const submissionUpdates = (ripple_id, data) => {
        submitConfigurations(false, ripple_id)
        if (data.hasOwnProperty('errors')) {
            // some error
            errors.push(data.errors)
        }
        let tempSet = new Set(requestQueRef.current)
        tempSet.delete(ripple_id)
        if (tempSet.size == 0) {
            if (errors.length == 0) {
                props.submissionUpdates(true, {})
            } else {
                props.submissionUpdates(false, errors)
            }
        }
        requestQueRef.current = new Set(tempSet)

    }

    const onRegister = (rippleId) => {
        let tempSet = new Set(rippleIds)
        tempSet.add(rippleId)
        setRippleIds(new Set(tempSet))
    }

    const onDeRegister = (rippleId) => {
        let tempSet = new Set(rippleIds)
        if (rippleId.startsWith('temp_ripple_id')) {
            // mark to delete
            tempSet.delete(rippleId)
        } else {
            // tempSet.delete(rippleId)
            deleteRequestRef.current.add(rippleId)
        }
        setRippleIds(new Set(tempSet))
    }

    const notifyUpdates = (key, value, rippleId = null) => {
        rippleConfigurationComponentsRef.current = rippleConfigurationComponentsRef.current.map(component => {
            let newProps = { ...component.props, mappingId: props.mappingId, appId: props.appId }
            if (rippleId) {
                if (component.props.rippleConfiguration.ripple_id == rippleId || component.props.rippleConfiguration.temp_ripple_id == rippleId) {
                    newProps[key] = value
                    return React.cloneElement(component, newProps);
                } else {
                    return React.cloneElement(component, newProps);
                }
            } else {
                newProps[key] = value
                return React.cloneElement(component, newProps);
            }


        });
        setRippleConfigurationComponents([...rippleConfigurationComponentsRef.current]);
    }

    const submitConfigurations = (value, rippleId = null) => {
        notifyUpdates('shouldSubmit', value, rippleId)
    }

    const resetViews = () => {
        setRippleIds(new Set())
        setRippleConfigurationComponents([])
        rippleConfigurationComponentsRef.current = []
        requestQueRef.current = new Set()
    }

    const initView = () => {
        resetViews()
        if (!props.isNewMode) {
            setLoading("Fetching post processing information..")

            getAllRipples(props.mappingId, props.idType, function onSuccess(response) {
                let components = []
                for (let i = 0; i < response.data.getAllRipples.length; i++) {
                    components.push(<RippleComponent
                        isEditMode={props.isEditMode}
                        isNewMode={props.isNewMode}
                        submissionUpdates={submissionUpdates}
                        mappingId={props.mappingId}
                        appId={props.appId}
                        idType={props.idType}
                        rippleConfiguration={JSON.parse(JSON.stringify(response.data.getAllRipples[i]))}
                        register={onRegister}
                        deRegister={onDeRegister}
                    />)
                }
                setRippleConfigurationComponents(components)
                rippleConfigurationComponentsRef.current = components
                setLoading(null)
            }, function onFailure(response) {
                setLoading(null)
            })
        }

    }

    const addRow = () => {
        rippleConfigurationComponentsRef.current = [...rippleConfigurationComponentsRef.current,
        <RippleComponent
            isEditMode={props.isEditMode}
            isNewMode={props.isNewMode}
            submissionUpdates={submissionUpdates}
            mappingId={props.mappingId}
            appId={props.appId}
            idType={props.idType}
            rippleConfiguration={{ approval_required: false, resend_old_parameters: false }}
            register={onRegister}
            deRegister={onDeRegister}
        />
        ];
        setRippleConfigurationComponents([...rippleConfigurationComponentsRef.current]);

    }

    const getAddButton = () => {
        return <div> <Button onClick={addRow}>Add</Button> </div>
    }

    const getInputItem = (value, index) => {
        return <div key={index}>
            {value}
        </div>
    }

    return (
        <Box>
            {
                loading ? <>  <span className="grey_text"> <Spinner></Spinner> {loading}</span></> : <>
                    {
                        (rippleConfigurationComponents?.length > 0 || props.isEditMode || props.isNewMode) &&
                        <Box variant="h1">Post-process configuration</Box>
                    }

                    {rippleConfigurationComponents ? (Array.from(rippleConfigurationComponents).map((value, index) => {
                        return getInputItem(value, index);
                    })) : ''}

                    {rippleConfigurationComponents?.length < props.maxConfigurations && (props.isEditMode || props.isNewMode) ?
                        getAddButton() : <></>
                    }
                </>
            }
        </Box>

    )
}

export default RippleComponentManager;